import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { MechanismSection } from './MechanismSection';
import { WhatYouGetSection } from './WhatYouGetSection';
import { WhoIsForSection } from './WhoIsForSection';
import { HowItWorksSection } from './HowItWorksSection';
import { ProofSection } from './ProofSection';
import { FAQSection } from './FAQSection';
import { OfferSection } from './OfferSection';
import { FooterSection } from './FooterSection';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-white" data-id="element-77">
      <HeroSection data-id="element-78" />
      <ProblemSection data-id="element-79" />
      <MechanismSection data-id="element-80" />
      <WhatYouGetSection data-id="element-81" />
      <WhoIsForSection data-id="element-82" />
      <HowItWorksSection data-id="element-83" />
      <ProofSection data-id="element-84" />
      <FAQSection data-id="element-85" />
      <OfferSection data-id="element-86" />
      <FooterSection data-id="element-87" />
    </div>;
}